import { DraftsState } from '~src/drafts/types/DraftsTypes';
import { AppState } from '../state/AppState';


export function selectDrafts(state: AppState): DraftsState {
  return state.drafts;
}
